module.exports = __webpack_public_path__ + "573f6ecc1133f263726257813bfc5536.png";


//////////////////
// WEBPACK FOOTER
// ./src/containers/diamond/images/caratScale/4.00ct.png
// module id = 804
// module chunks = 0